import React, { useState } from 'react'
import { Plus } from '@phosphor-icons/react'
import LateFee from '../Modals/LateFee/LateFee'
import { classesEventStore } from 'state/classes/classesStore'
import { ClassesLateFee } from 'types/Classes/Classes'
import LateFeeComp from './LateFeeComp'

interface ClassesDataShape {
  _id: string
  lateFee?: ClassesLateFee
}

const LateFeeRow: React.FC = () => {
  const classesData = classesEventStore(store => store.classesData) as any
  const lateFee = classesData?.lateFee

  const [lateFeeModalOpen, setLateFeeModalOpen] = useState<boolean>(false)

  const handleAddClick = () => {
    setLateFeeModalOpen(true)
  }

  return (
    <>
      <div className="mt-20px">
        <div className="flex align-center justify-between ">
          <div>
            <p className="text-16 w-600">Late Fee</p>
          </div>
          {!lateFee && (
            <div
              className="w-36px h-36px radius-rounded bg-blue flex align-center justify-center pointer"
              onClick={handleAddClick}
            >
              <Plus size={12} color="#fff" />
            </div>
          )}
        </div>

        <div className="grid-50">
          {lateFee && (
            <LateFeeComp
              details={lateFee}
            />
          )}
        </div>

      </div>

      {lateFeeModalOpen && (
        <LateFee
          modalOpen={lateFeeModalOpen}
          modalClose={setLateFeeModalOpen}
        />
      )}
    </>
  )
}

export default LateFeeRow
